import React, { useState, useEffect } from "react";
import {
  faArrowRight,
  faCalendarDay,
  faChevronRight,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import authLogo from "../../assets/logo/favIcon.png";
// import img1 from "../../assets/All Images/hire-destintion.jpg";
// import img2 from "../../assets/All Images/hire-challenges.jpg";
// import img3 from "../../assets/All Images/hire-strategies.jpg";
import Spinner from "../../Components/seperate Components/Spinner";
import Reply from "./Reply";
import moment from "moment/moment";

const CompanyBlogs = ({ posts, isLoading }) => {
  const { permalink } = useParams();
  const [comments, setComments] = useState([]);

  const fetchComments = async () => {
    try {
      const { data } = await axios.get(
        "https://mars.zithas.com/api/comment_reply"
      );
      setComments(data.length);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchComments();
  }, []);

  return (
    <div>
      <section>
        <div className="container pt-80">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="col-md-12">
                <div className="bd-blog mb-30 grid">
                  <div className="bd-blog-img">
                    <Link to={`/blog/blog-details`}>
                      <img
                        // src={img1}
                        alt="blog image not found"
                        style={{ width: "410px", height: "250px" }}
                      />
                      {/* {imageVideo} */}
                    </Link>
                  </div>
                  <div className="bd-blog-text">
                    {/* <div className="bd-blog-meta mb-15">
                      <ul>
                        <li>
                          <Link
                            to={`/blog/blog-details`}
                            style={{ textTransform: "none" }}
                          >
                            <i>
                              {" "}
                              <FontAwesomeIcon icon={faCalendarDay} />
                            </i>
                            Feb 13, 2024
                          </Link>
                        </li>
                        <li>
                          <Link to={`/blog/blog-details`}>
                            <i>
                              <FontAwesomeIcon icon={faMessage} />
                            </i>
                            0 Comments
                          </Link>
                        </li>
                      </ul>
                    </div> */}
                    <h4 className="bd-blog-title mb-40">
                      <Link to={`/blog/blog-details`}>
                        Is the Perfect Destination to Hire Skilled Resources for
                        Your Business
                      </Link>
                    </h4>
                    <div className="bd-blog-author">
                      <div className="bd-blog-author-info">
                        <img src={authLogo} alt="author image not found" />
                        <h6 className="bd-blog-author-info-title">Florance</h6>
                      </div>
                      <div className="bd-blog-author-link">
                        <Link to={`/blog/blog-details`}>
                          Read More{" "}
                          <i>
                            <FontAwesomeIcon icon={faArrowRight} />
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="col-md-12">
                <div className="bd-blog mb-30 grid">
                  <div className="bd-blog-img">
                    <Link to={`/blog/blog-details`}>
                      <img
                        // src={img3}
                        alt="blog image not found"
                        style={{ width: "410px", height: "250px" }}
                      />
                      {/* {imageVideo} */}
                    </Link>
                  </div>
                  <div className="bd-blog-text">
                    {/* <div className="bd-blog-meta mb-15">
                      <ul>
                        <li>
                          <Link
                            to={`/blog/blog-details`}
                            style={{ textTransform: "none" }}
                          >
                            <i>
                              {" "}
                              <FontAwesomeIcon icon={faCalendarDay} />
                            </i>
                            Feb 13, 2024
                          </Link>
                        </li>
                        <li>
                          <Link to={`/blog/blog-details`}>
                            <i>
                              <FontAwesomeIcon icon={faMessage} />
                            </i>
                            0 Comments
                          </Link>
                        </li>
                      </ul>
                    </div> */}
                    <h4 className="bd-blog-title mb-40">
                      <Link to={`/blog/blog-details`}>
                        Top Strategies for Hiring IT Resources: A Guide for
                        Global Companies
                      </Link>
                    </h4>
                    <div className="bd-blog-author">
                      <div className="bd-blog-author-info">
                        <img src={authLogo} alt="author image not found" />
                        <h6 className="bd-blog-author-info-title">Florance</h6>
                      </div>
                      <div className="bd-blog-author-link">
                        <Link to={`/blog/blog-details`}>
                          Read More{" "}
                          <i>
                            <FontAwesomeIcon icon={faArrowRight} />
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6">
              <div className="col-md-12">
                <div className="bd-blog mb-30 grid">
                  <div className="bd-blog-img">
                    <Link to={`/blog/blog-details`}>
                      <img
                        // src={img2}
                        alt="blog image not found"
                        style={{ width: "410px", height: "250px" }}
                      />
                      {/* {imageVideo} */}
                    </Link>
                  </div>
                  <div className="bd-blog-text">
                    {/* <div className="bd-blog-meta mb-15">
                      <ul>
                        <li>
                          <Link
                            to={`/blog/blog-details`}
                            style={{ textTransform: "none" }}
                          >
                            <i>
                              {" "}
                              <FontAwesomeIcon icon={faCalendarDay} />
                            </i>
                            Feb 13, 2024
                          </Link>
                        </li>
                        <li>
                          <Link to={`/blog/blog-details`}>
                            <i>
                              <FontAwesomeIcon icon={faMessage} />
                            </i>
                            0 Comments
                          </Link>
                        </li>
                      </ul>
                    </div> */}
                    <h4 className="bd-blog-title mb-40">
                      <Link to={`/blog/blog-details`}>
                        Navigating the Challenges of Hiring Resources
                      </Link>
                    </h4>
                    <div className="bd-blog-author">
                      <div className="bd-blog-author-info">
                        <img src={authLogo} alt="author image not found" />
                        <h6 className="bd-blog-author-info-title">Florance</h6>
                      </div>
                      <div className="bd-blog-author-link">
                        <Link to={`/blog/blog-details`}>
                          Read More{" "}
                          <i>
                            <FontAwesomeIcon icon={faArrowRight} />
                          </i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CompanyBlogs;
